import { Box, Card, CardContent, Typography } from "@mui/material";
import { IBacklinkImpressions, IBacklinkSessions } from "../../types";

interface StatsCardsProps {
  impressions: IBacklinkImpressions | null;
  sessions: IBacklinkSessions | null;
}

interface StatCardProps {
  label: string;
  value: number | string;
}

function StatCard({ label, value }: StatCardProps) {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        <Typography variant="h5" fontWeight={700}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}

function formatNumber(n: number): string {
  return n.toLocaleString("pt-BR");
}

export function StatsCards({ impressions, sessions }: StatsCardsProps) {
  return (
    <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
      <StatCard
        label="Visibilidade editorial"
        value={impressions ? formatNumber(impressions.impressions) : "—"}
      />
      <StatCard
        label="Visitantes únicos"
        value={sessions ? formatNumber(sessions.sessions) : "—"}
      />
      <StatCard
        label="Cliques"
        value={
          impressions?.clicks !== undefined
            ? formatNumber(impressions.clicks)
            : "—"
        }
      />
    </Box>
  );
}
